import { inject, Injectable } from '@angular/core';
import { TenantService } from '@app/plateformebeneficiaire/core/service/tenant.service';

@Injectable({ providedIn: 'root' })
export class AuthenticationService {
  #tenantService = inject(TenantService);

  private baseUrl: string | null;

  constructor() {
    this.baseUrl = this.#tenantService.getBffBaseUrl();
  }

  redirectToLogin() {
    window.location.href = `${this.baseUrl}/bff/login?returnUrl=${window.location.origin}/auth/callback`;
  }
}
